import { useEffect, useState } from 'react'
import './spocTable.css';
import DataTable from '../DataTable/DataTable';
import AutoComplete from '../AutoComplete/AutoComplete';
import TextField from '@mui/material/TextField';

const ManageSpocTable = ({ spocs, isloading, onEdit, userType }) => {
    const [spocsData, setSpocsData] = useState([]);
    const activityOptions = [
        { label: 'All', value: '' },
        { label: 'True', value: 'true' },
        { label: 'False', value: 'false' }
    ]

    const handleEditClick = (rowData) => {
        onEdit(rowData);
    };

    function isActiveFilterFn(row, columnId, filterValue) {
        if (!filterValue) return true; // no filter
        const rowValue = row.getValue(columnId);
        const filterValLower = filterValue.toLowerCase();
        if (filterValLower === 'true') return rowValue === true;
        if (filterValLower === 'false') return rowValue === false;
        return true;
    }

    const getIsActiveFilterValue = (column) => {
        const filterValue = column.getFilterValue();
        const activityOptions = [
            { label: 'All', value: '' },
            { label: 'True', value: 'true' },
            { label: 'False', value: 'false' }
        ];
        let value = activityOptions.find(opt => opt.value === filterValue);
        if (!value) {
            value = { label: 'All', value: '' };
        }
        return value;
    }


    const columns = [
        {
            accessorKey: "spocName",
            header: "Name",
            size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "clientName",
            header: "Client",
            size: 150,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "spocEmail",
            header: "Email",
            size: 180,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
        {
            accessorKey: "isActive",
            header: "Is Active",
            size: 80,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: isActiveFilterFn,
            cell: ({ getValue }) => (getValue() ? "True" : "False"),
            Filter: ({ column }) => (
                <AutoComplete
                    disableClearable
                    className='isActiveFilter-autocomplete'
                    options={activityOptions}
                    value={getIsActiveFilterValue(column)}
                    onChange={(event, newValue) => {
                        column.setFilterValue(newValue ? newValue.value : '');
                    }}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                        />
                    )}
                    sx={{ width: '100%' }}
                />
            )
        },
        {
            id: "action",
            header: "Action",
            cell: ({ row }) => (
                <>
                    <button
                        className='editBtn_manageSpoc'
                        disabled={userType === 'Admin' ? true : false}
                        onClick={() => handleEditClick(row.original)}
                    >
                        Edit
                    </button>
                </>
            ),
            size: 80,
            enableSorting: false,
            enableColumnFilter: false,
        },
    ]

    useEffect(() => {
        let arr = [];
        for (let i = 0; i < spocs.length; i++) {
            spocs[i].clientName = spocs[i]?.client[0]?.clientName;
            arr.push(spocs[i]);
        }
        setSpocsData(arr);
    }, [spocs])

    return (
        <>
            <DataTable
                data={spocsData}
                columns={columns}
                isLoading={isloading}
                initialColumnFilters={[
                    {
                        id: 'isActive',
                        value: 'true'
                    }
                ]}
            />
        </>
    )
}

export default ManageSpocTable;